import Swiper from 'swiper/bundle';

export function initUspSwipers(scope = document) {
  scope.querySelectorAll('[data-usp-swiper-root]').forEach((root) => {
    const el = root.querySelector('.js-usp-swiper');
    if (!el) return;

    if (el._swiper && typeof el._swiper.destroy === 'function') {
      el._swiper.destroy(true, true);
      el._swiper = null;
    }

    let data = {};
    try { data = JSON.parse(el.getAttribute('data-options') || '{}'); } catch (_) {}

    const next = root.querySelector('.usp-next');
    const prev = root.querySelector('.usp-prev');
    const fill = root.querySelector('.js-usp-fill');

    const opts = { ...data };

    if (opts.autoplay === true) {
      const d = (typeof opts.delay === 'number' && opts.delay > 0) ? opts.delay : 3500;
      opts.autoplay = { delay: d, disableOnInteraction: false, pauseOnMouseEnter: true };
    } else if (opts.autoplay === false) {
    } else if (typeof opts.autoplay === 'object' && opts.autoplay !== null) {
      if (typeof opts.autoplay.delay !== 'number') {
        opts.autoplay.delay = (typeof opts.delay === 'number' ? opts.delay : 3500);
      }
    }

    opts.navigation = (next && prev) ? { nextEl: next, prevEl: prev } : undefined;

    function updateFill(sw) {
      if (!fill) return;
      const p = sw.progress;
      const clamped = typeof p === 'number' ? Math.max(0, Math.min(1, p)) : 0;
      fill.style.transform = `scaleX(${0.2 + clamped * 0.8})`;
    }

    opts.on = {
      init() {
        updateFill(this);
      },
      setTranslate() {
        updateFill(this);
      },
      transitionEnd() {
        updateFill(this);
      },
      slideChange() {
        updateFill(this);
      }
    };

    el._swiper = new Swiper(el, opts);

    const toggleNav = () => {
      if (!next || !prev) return;
      const bp = el._swiper.currentBreakpoint;
      const spv =
        (bp && el._swiper.params.breakpoints?.[bp]?.slidesPerView) ??
        el._swiper.params.slidesPerView ?? 1;
      const total = el._swiper.slides.length;
      const show = total > (typeof spv === 'number' ? spv : 1);
      next.style.display = show ? '' : 'none';
      prev.style.display = show ? '' : 'none';
    };

    el._swiper.on('afterInit resize breakpoint slidesLengthChange', toggleNav);
    toggleNav();
  });
}


export function initTrustpilotBarSwipers(scope = document) {
  scope.querySelectorAll('[data-trustpilot-bar-swiper-root]').forEach((root) => {
    const el = root.querySelector('.js-trustpilot-bar-swiper');
    if (!el) return;

    const next = root.querySelector('.trustpilot-next');
    const prev = root.querySelector('.trustpilot-prev');

    if (el._trustpilotSwiper && typeof el._trustpilotSwiper.destroy === 'function') {
      el._trustpilotSwiper.destroy(true, true);
      el._trustpilotSwiper = null;
    }

    el._trustpilotSwiper = new Swiper(el, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 800,
      watchOverflow: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: next && prev ? {
        nextEl: next,
        prevEl: prev
      } : undefined
    });

    if (el._trustpilotSwiper.autoplay) {
      el._trustpilotSwiper.autoplay.start();
    }

    if (next) next.style.display = 'flex';
    if (prev) prev.style.display = 'flex';
  });
}